import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=4754e00b&scoped=true&"
import script from "./Submenu.vue?vue&type=script&lang=js&"
export * from "./Submenu.vue?vue&type=script&lang=js&"
import style0 from "./Submenu.vue?vue&type=style&index=0&id=4754e00b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754e00b",
  null
  
)

export default component.exports